import { render, staticRenderFns } from "./DmDashboard.vue?vue&type=template&id=f53df108&scoped=true"
import script from "./DmDashboard.vue?vue&type=script&lang=js"
export * from "./DmDashboard.vue?vue&type=script&lang=js"
import style0 from "./DmDashboard.vue?vue&type=style&index=0&id=f53df108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53df108",
  null
  
)

export default component.exports